<template>
  <div id="chart-line">

    <apexchart ref="apexTime" id="apexTime" @zoomed="xZoomed" v-observe-visibility="visibilityChanged" type="line"
      height="200" :options="chartOptions" :series="series"></apexchart>
    <el-button v-if="showToggleUnit" @click="toggleUnit" size="mini">Unit {{ this.unit }}</el-button>
    <el-button @click="playAudio" size="mini" icon="el-icon-video-play"></el-button>
    <el-dropdown size="mini" @command="handleCommand" trigger="click" style="margin-left:10px;">
      <el-button size="mini">
        {{ $t("common.download") }}
        <em class="fas fa-download"></em>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="csvDownload">
          {{ $t("common.csvDownload") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-checkbox style="margin-left:15px;" v-model="dcOffsetEnabled">DC Offset</el-checkbox>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { _ } from "vue-underscore";
import { mapState, mapActions } from "vuex";
import { signalProcessing, preferences } from "../util";
import { apexTimeDownload } from "../util";
export default {
  name: "time-chart",
  events: [],
  props: {
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: "G",
    },
    showToggleUnit: {
      type: Boolean,
      default: true
    }
  },
  event: "input",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      playIcon: "el-icon-video-play",
      mouseBeforeX: 0,
      dcOffsetEnabled: true,
      mouseAfterX: 0,
      activeDataPointIndex: 0,
      timeDomain: [],
      activeData: "",
      zoomLevel: 0,
      slicedFreqIndexs: [],
      zoomOffset: 20,
      window: "rectangular",
      TimeSerie: [],
      harmonicCount: 0,
      harmonicArr: [],
      series: [
        {
          data: [],
        },
      ],
      unit: "G",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
      anootationPosition: 0,
      chartOptions: {
        tooltip: {
          enabled: true,
          shared: true,
          followCursor: false,
          style: {
            fontSize: "15px",
            fontFamily: undefined,
          },
          onDatasetHover: {},
          x: {
            show: false,
          },
          y: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        selection: {
          enabled: true,
        },
        chart: {
          id: "chart",
          type: "line",
          defaultLocale: "en",
          toolbar: {
            tools: {
              download: false,
              pan: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              reset: true,
            },
            autoSelected: "zoom",
            show: true,
          },
          locales: [
            {
              name: "en",
              options: {
                toolbar: {
                  selection: this.$t("chart.toolbar.selection"),
                  selectionZoom: this.$t("chart.toolbar.selectionZoom"),
                  zoomIn: this.$t("chart.toolbar.zoomIn"),
                  zoomOut: this.$t("chart.toolbar.zoomOut"),
                  reset: this.$t("chart.toolbar.reset"),
                },
              },
            },
          ],

          animations: {
            enabled: false,
            dynamicAnimation: {
              enabled: false,
            },
          },
        },

        colors: ["#00519D"],
        stroke: {
          width: 1,
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        yaxis: {
          type: "numeric",
          labels: {
            formatter: function (e) {
              try {
                return parseFloat(e).toFixed(4);
              } catch (e) {
                return 0;
              }
            },
          },
        },
        xaxis: {
          type: "numeric",
          title: {
            text: `${this.$t("chart.time")} (s)`,
            offsetY: 80
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(4);
            },
          },
        },
      },
    };
  },
  mounted() {
    window.addEventListener("mousedown", this.mouseDown);

  },
  computed: {
    ...mapState("measurementsDetails", ["rawdataIndex"]),
    Scnd: function () {
      return (
        Number(this.timeDomain[this.activeDataPointIndex]).toFixed(4) + ` s`
      );
    },
    Value: function () {
      try {
        if (!this.activeData.length) return "";
        return this.activeData[this.activeDataPointIndex].toFixed(6) + this.unit;
      } catch (e) {
        return 0;
      }
    },
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "csvDownload":
          apexTimeDownload.csvDownload(this, "apexTime");
          break;
      }
      setTimeout(() => {
        this.init();
      }, 100);
    },
    playAudio() {

      if (this.activeData) {

        const audioContext = new AudioContext({ sampleRate: this.samplingRate });
        // create audio buffer of the same length as our array
        const audioBuffer = audioContext.createBuffer(1, this.activeData.length, this.samplingRate);
        // this copies our sine wave to the audio buffer
        audioBuffer.copyToChannel(Float32Array.from(this.activeData), 0);
        // some JavaScript magic to actually play the sound
        const source = audioContext.createBufferSource();

        source.buffer = audioBuffer;
        source.connect(audioContext.destination);
        source.start();


      }
    },
    toggleUnit() {
      if (this.unit == "mm/s²") {
        this.unit = "G";
      } else {
        this.unit = "mm/s²";
      }
      this.init();
    },
    xZoomed(a, { xaxis }) {
      // console.log(xaxis.min)
      // console.log(this.timeDomain)
      // let minIndex = this.timeDomain.findIndex( x=> x== xaxis.min)
      // let maxIndex = this.timeDomain.indexOf(xaxis.max)
      let min = xaxis.min == undefined ? -1 : xaxis.min;
      let max = xaxis.max == undefined ? Number.MAX_SAFE_INTEGER : xaxis.max;
      let start = this.timeDomain.findIndex((x) => x >= min);
      let end = this.timeDomain.findIndex((x) => x >= max);
      start = start == -1 ? 0 : start;
      end = end == -1 ? this.timeDomain.length - 1 : end;
      this.$emit("input", [start, end]);
      this.$emit("childTimeDomain", [min, max])
      this.updateRawdataIndex({
        minIndex: 0,
        minValue: start,
        maxIndex: 0,
        maxValue: end,
      });
    },
    ...mapActions("measurementsDetails", ["updateRawdataIndex"]),
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    visibilityChanged(a) {
      if (a) {
        this.init();
      }
    },
    DC_Offset(data) {
      if (this.dcOffsetEnabled) {
        const average = data.reduce((p, c) => p + c, 0) / data.length; // calculate average
        var normalized = data.map((x) => x - average); // normalize raw data by subtracting average and multiplying by gravity constant

        return normalized;
      } else {
        return data;
      }
    },
    init() {

      const normalized = this.DC_Offset(this.rawData);
      this.TimeSerie = signalProcessing.Window(normalized, this.window);

      this.timeDomain = _.range(normalized.length + 1).map(
        (x) => x / this.samplingRate
      );
      this.$emit('childTimeDomain', [this.timeDomain[0], this.timeDomain[this.timeDomain.length - 1]])
      this.PrepareDataToPlot();



    },

    PrepareDataToPlot() {
      this.activeData = [];

      this.activeData = this.TimeSerie;
      let multiplier = 1;
      if (this.unit == "mm/s²") {
        multiplier = 9.8065;
      }
      this.activeData = this.activeData.map((x) => x * multiplier);
      let serie_data = this.activeData.map((a, i) => {
        return [this.timeDomain[i], a];
      });
      let minYaxis = Math.min(...this.activeData) * 1.1;
      let maxYaxis = Math.max(...this.activeData) * 1.1;
      this.series = [
        {
          name: this.unit,
          data: serie_data,
        },
      ];
      this.chartOptions = {
        xaxis: {
          type: "numeric",
        },
        yaxis: {
          tickAmount: 5,
          min: minYaxis,
          maxYaxis: maxYaxis,
          title: {
            text: this.unit,
          },
          labels: {
            formatter: function (e) {
              return parseFloat(e).toFixed(4);
            },
          },
        },
      };
    },
  },
  watch: {
    dcOffsetEnabled: function (val) {
      this.init();
    },
    unit: function () {
      this.init();
    },
    rawData: function () {
      this.init();

    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}

.apexcharts-svg {
  height: 110%;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}

*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
